import WordPressArticle from './WordPressArticle';

export default WordPressArticle;
